import { Component, OnInit } from '@angular/core';
import { MemberQuery, PopulationQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { calculateAge, getKidType } from 'src/app/shared/utilities/age-ranges';
import { Populations } from 'src/app/shared/utilities/populations';
import { Tags } from 'src/app/shared/utilities/tags';

@Component({
  selector: 'fgb-worksheet-page',
  templateUrl: './worksheet-page.component.html',
  styleUrls: ['./worksheet-page.component.scss'],
})
export class WorksheetPageComponent implements OnInit {
  screenSize = ScreenType;
  isMemberKid: boolean = false;
  isAllStarKid: boolean = false;

  constructor(private populationQuery: PopulationQuery, private memberQuery: MemberQuery) {}

  ngOnInit() {
    const isKidsPopulation = this.populationQuery.userInPopulation([Populations.Kids]);
    const userContext = this.memberQuery.getUserContext();
    const customerTags = userContext.customerTags;
    this.isMemberKid = isKidsPopulation && (customerTags?.some((t) => t.TagName === Tags.JuniorMembers.TagName) ?? false);
    if (isKidsPopulation) {
      this.memberQuery.selectMemberDetails().subscribe((m) => {
        if (m) {
          this.isAllStarKid = getKidType(calculateAge(new Date(m.DOB))) === 'All-Stars';
        }
      });
    }
  }
}
